import { useEffect, useState } from "react";
import { getProductTypesTree } from "../api";
import {
  Center,
  Code,
  Container,
  Group,
  Loader,
  Title,
  Tree,
} from "@mantine/core";
import { IconFolder, IconFolderOpen } from "@tabler/icons-react";
import { Link } from "wouter";

function FileIcon({ name, isFolder, expanded }) {
  // if (name.endsWith('package.json')) {
  //   return <NpmIcon size={14} />;
  // }

  // if (name.endsWith('.ts') || name.endsWith('.tsx') || name.endsWith('tsconfig.json')) {
  //   return <TypeScriptCircleIcon size={14} />;
  // }

  // if (name.endsWith('.css')) {
  //   return <CssIcon size={14} />;
  // }

  if (isFolder) {
    return expanded ? (
      <IconFolderOpen
        color="var(--mantine-color-yellow-9)"
        size={14}
        stroke={2.5}
      />
    ) : (
      <IconFolder
        color="var(--mantine-color-yellow-9)"
        size={14}
        stroke={2.5}
      />
    );
  }

  return null;
}

function Leaf({ node, expanded, hasChildren, elementProps, marketplaceId }) {
  return (
    <Group gap={5} {...elementProps}>
      <FileIcon name={node.value} isFolder={hasChildren} expanded={expanded} />
      <span>
        <Code>{node.code}</Code> {node.label}
      </span>
      <Link to={`/marketplaces/${marketplaceId}/types/${node.value}`}>
        Details
      </Link>
    </Group>
  );
}

export default function ProductTypesTree({ params }) {
  const [productTypesTree, setProductTypesTree] = useState(null);

  useEffect(() => {
    getProductTypesTree(params.marketplaceId).then((data) => {
      setProductTypesTree(data);
    });
  }, []);

  if (!productTypesTree)
    return (
      <Center>
        <Loader />
      </Center>
    );

  return (
    <Container size="xl">
      <Title mb="lg" order={1}>
        Product types
      </Title>

      <Tree
        data={[productTypesTree]}
        renderNode={(payload) => (
          <Leaf {...payload} marketplaceId={params.marketplaceId} />
        )}
      />

      {/* <div>
        <Code block>{JSON.stringify(productTypesTree, null, 2)}</Code>
      </div> */}
    </Container>
  );
}
